<div class="resources-container">
  <h3>Revel Resources</h3>
  <button *ngIf="!viewMode" mat-raised-button color="primary" (click)="addResource()">Add Resource</button>

  <table *ngIf="resources.length > 0">
    <thead>
      <tr>
        <th>Name</th>
        <th>Type</th>
        <th>Is Link</th>
        <th *ngIf="!viewMode">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let resource of resources">
        <td>
          <span *ngIf="resource.isHyperlink">
            <a [href]="resource.path" target="_blank">{{ resource.name }}</a>
          </span>
          <span *ngIf="!resource.isHyperlink" (click)="onResourceClick($event, resource)" style="cursor: pointer; color: green; text-decoration: underline;">
            {{ resource.name }}
          </span>
        </td>
        <td>{{ resource.resourceType }}</td>
        <td>{{ resource.isHyperlink ? 'Yes' : 'No' }}</td>
        <td *ngIf="!viewMode">
          <button mat-button color="primary" (click)="editResource(resource)">Edit</button>
          <button mat-button color="warn" (click)="deleteResource(resource.id)">Delete</button>
        </td>
      </tr>
    </tbody>
  </table>

  <mat-card *ngIf="!viewMode && showResourceForm" class="resource-form">
    <mat-card-title>{{ selectedResource ? 'Edit Resource' : 'Add Resource' }}</mat-card-title>
    <mat-card-content>
      <form [formGroup]="resourceForm" (ngSubmit)="saveResource()">
        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Resource Type</mat-label>
          <input matInput formControlName="resourceType">
        </mat-form-field>

        <mat-checkbox formControlName="isHyperlink" (change)="onIsHyperlinkChange()">Is Hyperlink</mat-checkbox>

        <div>
          <label for="file-upload">Upload File:</label>
          <input id="file-upload" type="file" (change)="onFileSelected($event)" [disabled]="resourceForm.get('isHyperlink')?.value">
        </div>

        <mat-card-actions>
          <button mat-raised-button color="primary" type="submit">Save</button>
          <button mat-raised-button type="button" (click)="closeForm()">Cancel</button>
        </mat-card-actions>
      </form>
    </mat-card-content>
  </mat-card>
</div>
